export default __webpack_public_path__ + "static/media/logo-manage-user.a6d656b4.svg";